import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';
import LearnMoreLink from './components/LearnMoreLink';

import { userHasFeature } from '../../helpers/Features';

const EmptyFileStatus = ({ handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Track file progress with custom statuses' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Set custom statuses for files to suit your workflow. Know what’s in progress, ready, or approved without the guesswork.',
          })}
        </div>
        {userHasFeature('file-status') ? (
          <Button color="primary" className="mt-4" onClick={handleNewItem}>
            {intl.formatMessage({ defaultMessage: 'Create a file status' })}
          </Button>
        ) : (
          <UnlockButton feature="file-status" />
        )}
        <LearnMoreLink url="https://help.stockpress.co/en/articles/5937871-creating-file-statuses" />
      </Col>
      <EmptyStateVideo video="file-status" />
    </div>
  );
};

EmptyFileStatus.propTypes = {
  handleNewItem: PropTypes.func,
};

EmptyFileStatus.defaultProps = {
  handleNewItem: () => { },
};

export default EmptyFileStatus;
